import type {Editor, Range} from "@tiptap/core";
import type {Node as ProseMirrorNode} from "@tiptap/pm/model";
import type {PickerVariable} from "../model/types";
import {VARIABLE_NODE_NAME, variableInsertContent} from "../model/variableToken";

/*
    What follows `pos` in its textblock, as variableInsertContent reads it: the text up to the next
    node, a placeholder letter for a chip (two chips still want a space between them), a line break
    for any other leaf such as a hard break, and nothing at the end of the block.
 */
const followingText = (doc: ProseMirrorNode, pos: number) => {
    const next = doc.resolve(pos).nodeAfter;
    if (!next) return "";
    if (next.isText) return next.text ?? "";

    return next.type.name === VARIABLE_NODE_NAME ? "￼" : "\n";
};

/**
 * Inserts the chip for `variable` over `range` — the selection when there is none, as a toolbar
 * inserts — and focuses the editor. A space follows the chip only where the text needs one.
 */
export function insertVariable(editor: Editor, variable: PickerVariable, range?: Range): boolean {
    const {from, to} = range ?? editor.state.selection;

    return editor
        .chain()
        .focus()
        .insertContentAt({from, to}, variableInsertContent(variable, followingText(editor.state.doc, to)))
        .run();
}
